import { locale_ca_ES } from '../../locale/ca_ES/ca_ES';
import { locale_es_ES } from '../../locale/es_ES/es_ES';
import { locale_en_EN } from '../../locale/en_EN/en_EN';

const localeList = {
  ca_ES: locale_ca_ES,
  es_ES: locale_es_ES,
  en_EN: locale_en_EN
};

let current_locale = 'ca_ES';
let locale = localeList[current_locale];

export function changeLocale(localeName) {
  current_locale = localeName;
  locale = localeList[current_locale];
}

export function getLocale() {
  return current_locale;
}

export function getTranslatedKey(key) {
  if (locale[key] !== undefined) {
    return locale[key];
  } else {
    return 'TRANSLATE ERROR';
  }
}
